import request from '@/utils/request'
import request_python from '@/utils/request_python'

export function getActaActualizaciones(
  repo_id,
  repo_fecharecepcion,
  repo_fechasolucion
) {
  return request({
    url: `/actas/${repo_id}/${repo_fecharecepcion}/${repo_fechasolucion}`,
    method: 'get'
  })
}

export function getActaAom(data, fechacorte) {
  return request_python({
    url: '/acta/aom',
    method: 'post',
    data: data,
    params: { fechacorte }
  })
}

export function getAllActaAom(sort, filter, page, size, direction) {
  return request_python({
    url: '/acta/aom/all',
    method: 'get',
    params: { sort, filter, page, size, direction }
  })
}

export function getActaAomById(acco_id) {
  return request_python({
    url: '/acta/aom/print',
    method: 'get',
    params: { acco_id },
    responseType: 'blob'
  })
}

export function getGrabarActaAom(data, fechacorte) {
  return request_python({
    url: '/acta/aom/save',
    method: 'post',
    data: data,
    params: { fechacorte }
  })
}

export function getAllElements() {
  return request_python({
    url: '/acta/elementos',
    method: 'get'
  })
}

export function saveValorInfraestructura(data) {
  return request_python({
    url: '/acta/valor/infraestructura/save',
    method: 'post',
    data: data
  })
}

export function getAllActaValorInfra(sort, filter, page, size, direction) {
  return request_python({
    url: '/acta/valor/infra/all',
    method: 'get',
    params: { sort, filter, page, size, direction }
  })
}

export function getActaValorInfraById(acco_id) {
  return request_python({
    url: '/acta/valor/infra/print',
    method: 'get',
    params: { acco_id },
    responseType: 'blob'
  })
}
